import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { History } from '../../types/plan.interface'
import { getShellHistory } from '../actions/get-shell'
import { getUnitHistory } from '../actions/get-unit'

export interface HistoryState {
  error: string | null
  history: History | null
  loading: boolean
}

export const initialState: HistoryState = {
  error: null,
  history: null,
  loading: false,
}

export const fetchShellHistory = createAsyncThunk(
  '/shellHistory',
  async (communityPlanId: string) => {
    return (await getShellHistory(communityPlanId))?.data as History
  }
)

export const fetchUnitHistory = createAsyncThunk(
  '/unitHistory',
  async (communityPlanId: string) => {
    return (await getUnitHistory(communityPlanId))?.data as History
  }
)

export const getHistorySlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(fetchShellHistory.pending, (state) => {
        state.error = null
        state.loading = true
      })
      .addCase(fetchShellHistory.fulfilled, (state, action) => {
        state.history = action.payload
        state.error = null
        state.loading = false
      })
      .addCase(fetchShellHistory.rejected, (state, action) => {
        state.error = action.error.message ?? 'Error fetching shell history'
        state.loading = false
      })
      .addCase(fetchUnitHistory.pending, (state) => {
        state.error = null
        state.loading = true
      })
      .addCase(fetchUnitHistory.fulfilled, (state, action) => {
        state.history = action.payload
        state.error = null
        state.loading = false
      })
      .addCase(fetchUnitHistory.rejected, (state, action) => {
        state.error = action.error.message ?? 'Error fetching unit history'
        state.loading = false
      })
  },
  initialState,
  name: 'getHistory',
  reducers: {
    resetHistoryData: (state) => {
      state.history = null
      state.error = null
      state.loading = false
    },
  },
})

export const { resetHistoryData } = getHistorySlice.actions
